export default {
	auth_request(state) {
		state.status = "loading..";
	},
	auth_success(state, token, user) {
		state.status = "success";
		state.token = token;
		state.user = user;
	},
	auth_error(state, error) {
		state.status = error;
	},
	auth_error_login(state) {
		state.status = "Email / Password Salah";
	},
	logout(state) {
		state.status = "";
		state.token = "";
	},
};
